module.exports = __webpack_public_path__ + "assets/images/moon-li-1f08aea55924b334e2d74b207ca44934.jpg";